// Shared "first real user interaction" detector for the Truvolv beacons (form-started and
// step-started). `focusin` alone under-reports: WebKit (Safari/iOS) does not move focus to a
// button, checkbox, radio or select on click, so a genuine tap on a choice step went unrecorded.
// Listening for `pointerdown` as well covers mouse, touch and pen. Both listeners capture so they
// see the event before any handler can stop propagation, and both are removed once one fires.
export function onFirstInteraction(handler) {
  if (typeof document === 'undefined') {
    return () => {};
  }
  let fired = false;
  const remove = () => {
    document.removeEventListener('focusin', onInteraction, true);
    document.removeEventListener('pointerdown', onInteraction, true);
  };
  const onInteraction = () => {
    if (fired) return;
    fired = true;
    remove();
    handler();
  };
  document.addEventListener('focusin', onInteraction, true);
  document.addEventListener('pointerdown', onInteraction, true);
  return remove;
}
